import { IconButton } from '@material-ui/core';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid/Grid';
import Paper from '@material-ui/core/Paper/Paper';
import { WithStyles } from 'decorators/withStyles';
import { priceView } from 'formatters/priceMessage';
import { IProductNew } from 'interfaces/product';
import EditIcon from 'mdi-react/EditIcon';
import React, { Component } from 'react';
import { productNewService } from 'services/productNewService';
import { toastService } from 'services/toastService';
import TagItem from './TagItem/index';
import { productConfigurations } from 'data/productTags';
import AnnouncementIcon from 'components/Shared/TextAnnouncement/Icon';

interface IProps {
  key: number;
  classes?: any;
  product?: IProductNew;
  isFirst?: boolean;
}

interface IState {
  openEdit: boolean;
}

@WithStyles(theme => ({
  '@global': {
    '.MuiExpansionPanelSummary-content > :last-child ': {
      paddingRight: 0
    }
  },
  img: {
    width: 50,
    height: 50,
    border: '1px solid #efefef',
    borderRadius: 50,
    objectFit: 'cover'
  },
  imgOnMobile: {
    paddingRight: '1rem',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    '@media screen and (max-width: 900px)': {
      display: 'none'
    }
  },

  price: {
    color: '#009358',
    fontWeight: 'bold',
    marginRight: 5,
    textAlign: 'end'
  },
  name: {
    color: '#8E8E8E',
    marginRight: 5,
    wordBreak: 'break-word'
  },
  expansionPanel: {
    padding: '0px 8px',
    margin: '10px 0',
    border: '1px solid #ccc',
    borderRadius: 7
  },
  paperHover: {
    '&:hover': {
      boxShadow: '1px 1px 5px 2px #ccc'
    },
    transition: '0.2s ease-in-out',
    borderRadius: 7
  },
  container: {
    width: '100%',
    display: 'flex',

    '& p, span': {
      fontFamily: 'Lato, sans-serif',
      letterSpacing: '0.44px'
    }
  },
  iconTooltip: {
    position: 'relative',
    fill: '#4CAF50',
    left: 26,
    top: 2,
    [theme.breakpoints.down('md')]: {
      top: 19,
      fill: '#4CAF50',
      left: -22,
      right: 0,
      position: 'relative'
    },

    editButton: {
      marginLeft: 'auto'
    }
  },

  infoContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    '@media screen and (max-width: 900px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      gap: '0.5rem'
    }
  },

  pillsContainer: {
    marginRight: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  openButton: {
    marginLeft: 'auto'
  }
}))
export default class TabWithoutChildren extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { openEdit: false };
  }

  onClick = () => {
    const { product } = this.props;
    productNewService.setSelectedProduct(this.props.product);
    this.setState({ openEdit: true });

    if (product.toast) {
      toastService.loadToastsProduct(product.id);
    }
  };

  render() {
    const { classes, product, isFirst } = this.props;
    const { openEdit } = this.state;

    const productConfiguration = productConfigurations(product);

    return (
      <Paper elevation={0} classes={{ root: classes.paperHover }}>
        <ExpansionPanelSummary classes={{ root: classes.expansionPanel }} onClick={this.onClick}>
          <Grid className={classes.container}>
            <Grid item className={classes.imgOnMobile}>
              <img className={classes.img} src={product.image} />
            </Grid>
            <Grid xs={8} item container className={classes.infoContainer}>
              <Grid item xs={8}>
                <span className={classes.name}>{`${product.id} - ${product.name}`}</span>
              </Grid>

              <Grid item xs={3}>
                <span className={classes.price}>{priceView(product)}</span>
              </Grid>
            </Grid>

            {productConfiguration.length > 0 && (
              <Grid xs={4} item container className={classes.pillsContainer}>
                {productConfiguration.map(item => (
                  <TagItem {...item} key={item.label} />
                ))}
              </Grid>
            )}

            <Grid item className={classes.openButton}>
              {isFirst && <AnnouncementIcon hideIcon={openEdit} />}
              <IconButton>
                <EditIcon />
              </IconButton>
            </Grid>
          </Grid>
        </ExpansionPanelSummary>
      </Paper>
    );
  }
}
